import { type ComputedArrivalData } from "@src/appV2/redesign/ArrivalTime/computeArrivalData";
import { parseISO } from "date-fns";

import { ShiftBottomSheetBookabilityCriteriaCard } from "../BookabilityCriteriaCard";
import { ShiftBottomSheetArrivalTimeDescription } from "./Description";
import { ShiftBottomSheetArrivalTimeTitle } from "./Title";

interface ShiftBottomSheetArrivalTimeCardProps {
  computedArrivalData: ComputedArrivalData;
  workplaceTimezone: string;
}

export function ShiftBottomSheetArrivalTimeCard(props: ShiftBottomSheetArrivalTimeCardProps) {
  const { computedArrivalData, workplaceTimezone } = props;
  const startDatetime = parseISO(computedArrivalData.shiftStartIso);
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title={
        <ShiftBottomSheetArrivalTimeTitle
          computedArrivalData={computedArrivalData}
          workplaceTimezone={workplaceTimezone}
        />
      }
      description={
        <ShiftBottomSheetArrivalTimeDescription
          startDatetime={startDatetime}
          workplaceTimezone={workplaceTimezone}
        />
      }
      illustrationType="clock-error"
    />
  );
}
